import './Item.scss';
import useTranslation from '../../../../features/translation/hooks/useTranslation';
import { FC } from 'react';
import { RequestHandler } from '../../../../app/RequestHandler';
import { ShockAbsorberImage } from '../../../../interfaces';

interface ItemProps {
  orderCode: string;
  partNumber: string;
  img: ShockAbsorberImage;
  onClick: () => void;
}

enum TranslationKeys {
  SHOCK_ABSORBER = 'shockAbsorberName',
}

const Item: FC<ItemProps> = ({ orderCode, partNumber, img, onClick }) => {
  const t = useTranslation();
  const { country, language } = new RequestHandler();

  // Check whether user is in fox or not
  const foxShopUrl = window.location.href.includes('eac')
    ? `${process.env.REACT_APP_FESTO_URL}${country}/${language}/search/?text=${orderCode}`
    : `${process.env.REACT_APP_FESTO_URL}${country}/${language}/a/${partNumber}/?identCode1=${orderCode}`;

  return (
    <div className="es-search-result__column">
      <div className="es-header-container">
        <div className="fwe-d-flex">
          <div className="img-container">
            {img ? <img className="result-img" src={img.url} alt={img.altText} /> : null}
          </div>
          <div className="product-content">
            <p className="es-header-container__headline">{t(TranslationKeys.SHOCK_ABSORBER)}</p>
            <a href={foxShopUrl} target="_blank" rel="noopener noreferrer" onClick={onClick}>
              {orderCode}
            </a>
            <p className="ems-product-content__part-number">{partNumber}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Item;
